import { IUser } from '@contexts/AuthContext/type';

export function getAuthUserId(user: IUser | undefined): number | undefined {
  const id = user?.data?.id ?? user?.data?.user_info?.id;
  return typeof id === 'number' && !Number.isNaN(id) ? id : undefined;
}
